import { ColumnProps } from 'antd/lib/table';
import { ReactNode } from 'react';

export enum RegistroImpuestosEstado {
    SinCaptura = 'Sin Captura',
    Guardado = 'Guardado',
    Capturado = 'Capturado',
    Rechazado = 'Rechazado',
    Corregido='Corregido',
    Aprobado = 'Aprobado'
}
export interface RegistroImpuestos {
    id: number;
    estado: RegistroImpuestosEstado;
    comentarios: string;
    ejercicio?: number;
    mes?: number;
    municipioId?: number;
}

export interface RegistroImpuestosFormato {
    isSaved: boolean;
}

export type ImpuestosPredialDesgloseKeys = [
    'impuestoCobrado',
    'recargos',
    'multas',
    'gastosEjecucion',
    'interesesNoBancarios',
    'indemnizaciones'
];

export type ImpuestosPredialDesgloseKey = ImpuestosPredialDesgloseKeys[number];

export type ImpuestosPredialDesglose = Record<ImpuestosPredialDesgloseKey, number>;

export interface ImpuestosPredialIngresos extends RegistroImpuestosFormato {
    ingresosEjercicio: ImpuestosPredialDesglose;
    ingresosEjercicioAnterior: ImpuestosPredialDesglose;
}

export type ImpuestosPredialCuentasExistenteKeys = [
    'numeroDeCuentasUrbano',
    'numeroDeCuentasRustico'
];

export type ImpuestosPredialCuentasExistenteKey = ImpuestosPredialCuentasExistenteKeys[number];

export type ImpuestosPredialCuentasExistente = Record<ImpuestosPredialCuentasExistenteKey, number>;

export type ImpuestosPredialCuentasDePagosKeys = [
    'numeroDePagosEjercicio',
    'numeroDePagosEjercicioAnterior',
    'numeroDePagosEjercicioMixto'
];

export type ImpuestosPredialCuentasDePagosKey = ImpuestosPredialCuentasDePagosKeys[number];

export type ImpuestosPredialCuentasDePagos = Record<ImpuestosPredialCuentasDePagosKey, number>;

export type ImpuestosPredialCuentasAcumuladosKeys = [
    'numeroDePagosAcumuladoEjercicio',
    'numeroDePagosAcumuladoEjercicioAnterior',
    'numeroDePagosAcumuladoEjercicioMixto'
];

export type ImpuestosPredialCuentasAcumuladosKey = ImpuestosPredialCuentasAcumuladosKeys[number];

export type ImpuestosPredialCuentasAcumulados = Record<
    ImpuestosPredialCuentasAcumuladosKey,
    number
>;

export type ImpuestosPredialCuentas = RegistroImpuestosFormato &
    ImpuestosPredialCuentasExistente &
    ImpuestosPredialCuentasDePagos &
    ImpuestosPredialCuentasAcumulados;

export interface ImpuestosAguaCuentasRecord extends TableRecord {
    concepto: string;
}

export interface ImpuestosAguaIngresosPorUsoRecord extends TableRecord {
    concepto: string;
    usuario: number;
    toma: number;
    importe: number;
}

export interface ImpuestosPredialDescuentos extends RegistroImpuestosFormato {
    descuentosEjercicio: ImpuestosPredialDesglose;
    descuentosEjercicioAnterior: ImpuestosPredialDesglose;
}

export interface RegistroImpuestosPredial extends RegistroImpuestos {
    ingresos: ImpuestosPredialIngresos;
    cuentas: ImpuestosPredialCuentas;
    descuentos: ImpuestosPredialDescuentos;
}

export interface ImpuestosAguaDesglose {
    servicioAgua: number;
    conexiones: number;
    reconexiones: number;
    alcantarillado: number;
    drenaje: number;
    recargos: number;
    multas: number;
    gastosEjecucion: number;
    interesesNoBancarios: number;
    indemnizaciones: number;
    saneamiento: number;
}

export interface ImpuestosAguaIngresos extends RegistroImpuestosFormato {
    ingresosEjercicio: ImpuestosAguaDesglose;
    ingresosEjercicioAnterior: ImpuestosAguaDesglose;
}

export interface ImpuestosAguaDescuentos extends RegistroImpuestosFormato {
    descuentosEjercicio: ImpuestosAguaDesglose;
    descuentosEjercicioAnterior: ImpuestosAguaDesglose;
}

export interface AguaUsoUnidades {
    usuario: number;
    toma: number;
}

export interface AguaUsoRecaudacion extends AguaUsoUnidades {
    importe: number;
}

export interface AguaUsage<T> {
    domestico: T;
    noDomestico: T;
    otros: T;
}
export type ImpuestosAguaDesgloseRecord = ImpuestosDesgloseRecord;

export interface ImpuestosAguaCuentas extends RegistroImpuestosFormato {
    numeroDeCuentasEjercicioConMedidor: AguaUsage<AguaUsoUnidades>;
    numeroDeCuentasEjercicioAnteriorConMedidor: AguaUsage<AguaUsoUnidades>;
    numeroDeCuentasEjercicioSinMedidor: AguaUsage<AguaUsoUnidades>;
    numeroDeCuentasEjercicioAnteriorSinMedidor: AguaUsage<AguaUsoUnidades>;
    numeroCuentasPagosEjercicio: AguaUsoUnidades;
    numeroCuentasPagosEjercicioAnterior: AguaUsoUnidades;
    numeroCuentasPagosEjercicioMixto: AguaUsoUnidades;
}

export interface ImpuestosAguaIngresosPorUso extends RegistroImpuestosFormato {
    ingresosPorTiposUsoConMedidor: AguaUsage<AguaUsoRecaudacion>;
    ingresosPorTiposUsoSinMedidor: AguaUsage<AguaUsoRecaudacion>;
    numeroDePagosEjercicio: AguaUsoUnidades;
    numeroDePagosEjercicioAnterior: AguaUsoUnidades;
    numeroDePagosEjercicioMixto: AguaUsoUnidades;
}

export interface RegistroImpuestosAgua extends RegistroImpuestos {
    ingresos: ImpuestosAguaIngresos;
    ingresosPorUso: ImpuestosAguaIngresosPorUso;
    cuentas: ImpuestosAguaCuentas;
    descuentos: ImpuestosAguaDescuentos;
}

export interface TableRecord {
    key: string;
}

export interface ImpuestosDesgloseRecord extends TableRecord {
    concepto: string;
    importe: number;
}

export interface ImpuestosDesgloseTotalRecord extends ImpuestosDesgloseRecord {
    key: 'total';
    concepto: 'TOTAL';
}

export interface ImpuestosPredialCuentasExistenteRecord extends TableRecord {
    tipoDePredio: string;
    numeroDeCuentas: number;
}

export interface ImpuestosPredialCuentasExistenteTotalRecord
    extends ImpuestosPredialCuentasExistenteRecord {
    key: 'total';
    tipoDePredio: 'TOTAL';
}

export type ImpuestosPredialCuentasDePagosRecord = TableRecord &
    ImpuestosPredialCuentasDePagos & {
        numeroDePagosTotal: number;
    };

export type ImpuestosPredialCuentasAcumuladosRecord = TableRecord &
    ImpuestosPredialCuentasAcumulados & {
        numeroDePagosAcumuladoTotal: number;
    };

export interface ImpuestosAguaPagosRecord extends TableRecord {
    numeroDePagosEjercicio: number;
    numeroDePagosEjercicioAnterior: number;
    numeroDePagosEjercicioMixto: number;
}

export interface SaneamientoAguaRecord extends TableRecord {
    concepto: string;
    saneamiento: number;
    saneamientoAnterior: number;
    numeroDeSaneamientoAcumulado: number;
}

export type PredialInformacion =
    | ImpuestosPredialIngresos
    | ImpuestosPredialCuentas
    | ImpuestosPredialDescuentos;

export type AguaInformacion =
    | ImpuestosAguaIngresos
    | ImpuestosAguaIngresosPorUso
    | ImpuestosAguaCuentas
    | ImpuestosAguaDescuentos;

export interface Comentario {
    comentario: string;
}

export type TableColumns<T extends TableRecord> = Readonly<Array<ColumnProps<T>>>;

export type TableNumberRenderer = (path: string, value: number) => ReactNode;
